export default __webpack_public_path__ + "static/containers-do-6f5e33d8e502006322d8826672e3a13a.png";